module.exports = __webpack_public_path__ + "assets/sort_by_alpha.db2200dd.svg";